import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import api from '@shared/api'
import * as Sentry from "@sentry/vue";
import { useDiscountTimerStore } from './stores/discountTimer'
// Инициализация SVG спрайтов
import 'virtual:svg-icons-register'

const app = createApp(App)
const pinia = createPinia()

if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: "https://77f2dff823dbb78ce3a9ab605deb245a@o4510792172634112.ingest.us.sentry.io/4510793386229760",
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration()
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

// Добавляем API к глобальным свойствам
app.config.globalProperties.$api = api

app.use(pinia)
app.use(router)

// Инициализация discount timer
const discountTimerStore = useDiscountTimerStore()
discountTimerStore.init(20 * 60)

app.mount('#app')

